module.exports = __webpack_public_path__ + "img/move11.e58207dd.jpg";